import { Alert, Button, Center, Stack, Text } from "@mantine/core";
import { MdRefresh } from "react-icons/md";

interface LoadErrorAlertProps {
    title: string;
    error: string;
    onRetry: () => void;
}

export const LoadErrorAlert = ({ title, error, onRetry }: LoadErrorAlertProps) => (
    <Center h="100%" mih={220}>
        <Alert color="red" title={title} maw={480}>
            <Stack gap="sm">
                <Text size="sm">{error}</Text>
                <Button variant="light" size="xs" leftSection={<MdRefresh size={14} />} onClick={onRetry} w="fit-content">
                    Try again
                </Button>
            </Stack>
        </Alert>
    </Center>
);
